<!-- <p>face-timeline-table works!</p> -->
<mat-card
  [ngClass]="{
    'incident-table-card': screenSize == ScreenType.Desktop,
    'incident-table-card-tablet': screenSize == ScreenType.Tablet,

    'incident-table-card-mobile': screenSize == ScreenType.Mobile
  }"
>
  <mat-card-header
    [ngClass]="{
      'incident-table-card-header':
        screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,

      'incident-table-card-header-mobile': screenSize == ScreenType.Mobile
    }"
  >
    <div
      [ngClass]="{
        'incident-table-header':
          screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,

        'incident-table-header-mobile': screenSize == ScreenType.Mobile
      }"
    >
      <h3>
        {{ temp.isANPR ? tagLineAnpr : "Face recognition timeline" }}
      </h3>
    </div>
  </mat-card-header>
  <mat-card-content class="incident-table-card-content">
    <div *ngIf="screenSize != ScreenType.Mobile" class="visitors-table">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="source">
          <th
            style="text-align: center; border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
          >
            Camera
          </th>
          <td
            style="text-align: center; border-right: 1px solid"
            mat-cell
            *matCellDef="let element"
          >
            {{ temp.sourceAsset }}
          </td>
        </ng-container>
        <ng-container matColumnDef="location">
          <th
            style="text-align: center; border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
          >
            Location
          </th>
          <td
            style="text-align: center; border-right: 1px solid"
            mat-cell
            *matCellDef="let element"
          >
            {{ temp.incidentLocation }}
          </td>
        </ng-container>
        <ng-container matColumnDef="no">
          <th
            style="text-align: center; border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
          >
            No.
          </th>
          <td
            style="text-align: center; border-right: 1px solid"
            mat-cell
            *matCellDef="let element; let i = index"
          >
            {{ i + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th
            style="text-align: center; border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
          >
            Date
          </th>
          <td
            style="text-align: center; border-right: 1px solid"
            mat-cell
            *matCellDef="let element"
          >
            {{ getFormatedDate(element) | date : "fullDate" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="time">
          <th style="text-align: center" mat-header-cell *matHeaderCellDef>
            Time
          </th>
          <td style="text-align: center" mat-cell *matCellDef="let element">
            <!-- <b>{{ element | date : "hh:mm:ss a" }}</b> -->
            <b>{{ getFormatedDate(element) | date : "hh:mm:ss a" }}</b>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <div *ngIf="screenSize === ScreenType.Mobile">
      <app-mobile-table-card
        [incidentTimelineTableData]="mobileCardData"
        [tableType]="'incidentTimeline'"
      ></app-mobile-table-card>
    </div>
  </mat-card-content>
</mat-card>
